import { UrlConstants } from "./../models/urlConstants";
import { CompanyList } from "./../models/company-list";
import { Injectable } from "@angular/core";

import { Subject } from "rxjs";
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";

export class ErrorMessages {
  public static ErrMsgNoOptions: string =
    "Connection options not found. An options is required to connect to a SignalR Hub";
  public static ErrMsgNoUrl: string = "SignalR server URL not found.";
  public static ErrMsgNoHubName: string = "Hub name not found.";
  public static ErrMsgNojQuery: string =
    "jQuery not found. Ng2SignalRClientService requires jQuery. Ensure that jQuery is installed and available.";
  public static ErrMsgNoSignalR: string =
    "SignalR not found. Ng2SignalRClientService requires SignalR. Ensure that SignalR is installed and available.";
}

@Injectable()
export class SignalRService {
  private marketWatchConnection: HubConnection;
  private tradesConnection: HubConnection;
  private depthConnection: HubConnection;

  orderChanges: Subject<string> = new Subject<string>();
  tradeChanges: Subject<any[]> = new Subject<any[]>();
  marketChanges: Subject<CompanyList[]> = new Subject<CompanyList[]>();
  depthChanges: Subject<string> = new Subject<string>();
  summaryChanges: Subject<any> = new Subject<any>();
  newsChanges: Subject<any> = new Subject<any>();
  marketStatusChanges: Subject<any> = new Subject<any>();

  constructor() {}

  connectMarketWatch() {
    this.marketWatchConnection = new HubConnectionBuilder()
      .withUrl(UrlConstants.newSignalR + "/marketwatchHub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    this.marketWatchConnection
      .start()
      .then(() => {
        this.marketWatchConnection.on("sendMarketFeed", (update) => {
          this.marketChanges.next(update);
        });
        this.marketWatchConnection.on("SendMarketSummary", (update) => {
          this.summaryChanges.next(update);
        });
        this.marketWatchConnection.on("SendNewsFeed", (update) => {
          this.newsChanges.next(update);
        });
      })
      .catch( );
  }

  connectTradesUpdates() {
    this.tradesConnection = new HubConnectionBuilder()
      .withUrl(UrlConstants.newSignalR + "/tradesHub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();

    this.tradesConnection
      .start()
      .then(() =>
        this.tradesConnection.on("sendTrades", (update) => {
          this.tradeChanges.next(update);
        })
      )
      .catch();
  }

  // connectBidsAsksUpdates() {
  //   this.depthConnection = new HubConnectionBuilder()
  //     .withUrl("https://feedsignalr.egitdns.net/bidsAsksHub", {
  //       skipNegotiation: true,
  //       transport: signalR.HttpTransportType.WebSockets,
  //     })
  //     .build();

  //   this.depthConnection
  //     .start()
  //     .then(() =>
  //       this.depthConnection.on("sendBidsAsks", (update) => {
  //         this.depthChanges.next(update);
  //       })
  //     )
  //     
  // }

  public invoke() {}

  public disconnectMwSignalr() {
    if (this.marketWatchConnection) this.marketWatchConnection.stop();
  }

  public disconnectTradesSignalr() {
    if (this.tradesConnection) this.tradesConnection.stop();
  }
}
